import React from "react";
import { Heart, Trophy, Users, Zap } from "lucide-react"; 
import Card from "../components/Card/Card"; 

// Array of feature objects (data-driven approach)
const features = [
    {
        title: "Instant Recognition", 
        description: "Send meaningful shout-outs and power-ups to your team members in real-time.", 
        Icon: (
            // Icon wrapped inside a styled container (blue background circle)
            <div className="bg-blue-100 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full mb-3 md:mb-4">
                <Heart className="w-5 h-5 md:w-6 md:h-6 text-blue-400" />
            </div>
        )
    },
    {
        title: "Team Achievements",
        description: "Celebrate milestones and showcase success stories on digital displays.",
        Icon: (
            <div className="bg-blue-100 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full mb-3 md:mb-4">
                <Trophy className="w-6 h-6 text-blue-400" /> 
            </div>
        )
    },
    {
        title: "Stronger Culture",
        description: "Build a positive workplace culture through peer-to-peer recognition.",
        Icon: (
            <div className="bg-blue-100 w-12 h-12 flex items-center justify-center rounded-full mb-4">
                <Users className="w-6 h-6 text-blue-400" /> 
            </div>
        )
    },
    {
        title: "Boost Engagement",
        description: "Increase team motivation and engagement with regular appreciation.",
        Icon: (
            <div className="bg-blue-100 w-12 h-12 flex items-center justify-center rounded-full mb-4">
                <Zap className="w-6 h-6 text-blue-400" /> 
            </div>
        )
    },
];


const FeaturesSection: React.FC = () => {
    return (
        <section className="py-10 md:py-16 bg-gray-50"> {/* Section wrapper with padding and background */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> {/* Responsive container */}

                {/* Section title */}
                <h2 className="text-2xl md:text-3xl font-semibold text-blue-900 mb-3 text-center">
                    Why Teams Choose PowerUp
                </h2>

                {/* Subtitle/description */}
                <p className="text-gray-600 text-sm md:text-base mb-8 md:mb-12 text-center max-w-xl mx-auto">
                    Everything you need to build a recognition-rich culture that drives engagement and performance
                </p>

                {/* Grid wrapper for features */}
                <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
                    {features.map((feature, index) => (
                        <Card
                            key={index} // Unique key for React rendering
                            title={feature.title} // Pass feature title as prop
                            description={feature.description} // Pass feature description as prop
                            Icon={feature.Icon} // Pass feature icon as prop
                        />
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FeaturesSection; 
